<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Mobilization"
        title="Timesheets Deferred"
        subtitle="V1 focuses on planned mobilization assignments, lifecycle approvals, and audit history.">
        <div nav>
            <p-button label="Overview" icon="pi pi-chart-line" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization"></p-button>
            <p-button label="Entries" icon="pi pi-list" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization/entries"></p-button>
            <p-button label="Approvals" icon="pi pi-check-square" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization/change-requests"></p-button>
            <p-button label="History" icon="pi pi-history" severity="secondary" [outlined]="true" routerLink="/fleet/mobilization/history"></p-button>
        </div>
        <div actions>
            <p-button label="Open Mobilizations" icon="pi pi-list" routerLink="/fleet/mobilization/entries"></p-button>
        </div>
    </app-page-hero>

    <app-page-data-panel title="Timesheet Capture Is Not Enabled" subtitle="Detailed time capture will be implemented after the assignment workflow is stable.">
        <div class="empty-state">
            <i class="pi pi-calendar-clock"></i>
            <strong>No timesheet grid in v1</strong>
            <p>Use mobilization entries to plan assignments, approve them, activate live work, and complete the assignment lifecycle.</p>
            <p-button label="Go to Entries" icon="pi pi-arrow-right" routerLink="/fleet/mobilization/entries"></p-button>
        </div>
    </app-page-data-panel>
</app-page-shell>
